import { render, staticRenderFns } from "./edit-link.vue?vue&type=template&id=1c25c224&scoped=true&"
import script from "./edit-link.vue?vue&type=script&lang=js&"
export * from "./edit-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25c224",
  null
  
)

export default component.exports